import { storageConstants } from '../constants';
import { alertActions } from 'actions';
import * as token from 'helpers/token';
import { decode } from "jsonwebtoken";

export const userStorage = {
  hasUser,
  setUser,
  setPermissions,
  getPermissions,
  getUser,
  removeUser,
  getToken,
  updateProfile,
  saveOrder,
  removeOrder
};

function hasUser() {
  return localStorage.hasOwnProperty(storageConstants.USER);
}

function setUser(user) {
  const now = new Date();
  const userStorageValue = {
    account: user.account,
    token: user.token,
    expiry: now.getTime() / 1000 + storageConstants.TTL
  }
  localStorage.setItem(storageConstants.USER, JSON.stringify(userStorageValue));
}

function setPermissions(permissions) {
  const now = new Date();
  const loggedPermissions = {
    permissions: permissions,
    expiry: now.getTime() / 1000 + storageConstants.TTL
  }
  localStorage.setItem(storageConstants.PERMISSIONS, JSON.stringify(loggedPermissions));
}

function getPermissions() {
  if (localStorage.getItem(storageConstants.PERMISSIONS)) {
    const permissions = JSON.parse(localStorage.getItem(storageConstants.PERMISSIONS));
    return decode(permissions.permissions).rows;
  } else {

    return undefined;
  }


}

function getUser() {
  const userStorageValue = JSON.parse(localStorage.getItem(storageConstants.USER));
  // if the item doesn't exist, return null
  if (!userStorageValue) {
    return null;
  } else {
    const now = new Date();
    // compare the expiry time of the item with the current time
    if (now.getTime() / 1000 > userStorageValue.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      removeUser();
      setTimeout(function () { alertActions.warning('Timeout, please login again'); }, 500);
      return null;
    } else {
      setUser(userStorageValue);
    }
    return decode(userStorageValue.token);
  }
}

function updateProfile(userprofileUpdates) {
  const userStorageValue = JSON.parse(localStorage.getItem(storageConstants.USER));

  Object.assign(userStorageValue.account.userprofile, userprofileUpdates);

  // if the item doesn't exist, return null
  const now = new Date();
  const userUpdatedValue = {
    account: userStorageValue.account,
    token: userStorageValue.token,
    expiry: now.getTime() / 1000 + storageConstants.TTL
  }
  localStorage.setItem(storageConstants.USER, JSON.stringify(userUpdatedValue));
}

function getToken() {
  const userStorageValue = JSON.parse(localStorage.getItem(storageConstants.USER));
  // if the item doesn't exist, return null
  if (!userStorageValue) {
    return null;
  } else {
    const now = new Date();
    // compare the expiry time of the item with the current time
    if (now.getTime() / 1000 > userStorageValue.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      removeUser();
      setTimeout(function () { alertActions.warning('Timeout, please login again'); }, 500);
      return null;
    } else {
      setUser(userStorageValue);
    }
    return userStorageValue.token;
  }
}

function removeUser() {
  // localStorage.clear();
  localStorage.removeItem(storageConstants.USER);
  localStorage.removeItem(storageConstants.PERMISSIONS);
}

function saveOrder(order) {
  localStorage.setItem(storageConstants.TEMP_ORDER, JSON.stringify(order));
}

function removeOrder() {
  // localStorage.clear();
  localStorage.removeItem(storageConstants.TEMP_ORDER);
  localStorage.removeItem(storageConstants.PERMISSIONS);
}
